module.exports = __webpack_public_path__ + "static/user_profile_screen-85e0e7443a773f8768b7228ca526a0d6.png";